module.exports = __webpack_public_path__ + "img/link-btn.a882c5fc.png";